class NotifyMe extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.id;
    if (!this.productId) return;

    this.selectors = this.selectors || {};
    this.selectors.form = this.querySelector('form');
    this.selectors.formContent = this.querySelector('.notify-modal-form');
    this.selectors.email = this.querySelector('input[type="email"]');
    this.selectors.notifyModal = this.querySelector('[data-notify-me-modal]');
    this.selectors.notifyOpenBtn = this.querySelector('[data-notify-modal-open]');
    this.selectors.notifyCloseBtn = this.querySelector('[data-notify-modal-close]');
    this.selectors.notifySuccessMsg = this.querySelector('[data-notify-success-msg]');
    this.selectors.notifyProductGrid = this.closest('[data-product-id]');
    if (this.selectors.notifyModal) {
      this.selectors.notifyModal.setAttribute('role', 'dialog');
      this.selectors.notifyModal.setAttribute('aria-modal', 'true');
      this.selectors.notifyModal.setAttribute('aria-label', 'Notify me');
      this.selectors.notifyModal.setAttribute('tabindex', '-1');
    }

    this.selectors.notifyOpenBtn.addEventListener('click', this.show.bind(this));
    this.selectors.notifyCloseBtn.addEventListener('click', this.hide.bind(this));
    this.selectors.notifySubmitBtn = this.querySelector('.notify-modal-form .btn');
    this.selectors.notifySubmitBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.submit(event);
    });
    this.selectors.form?.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.submit(event);
    });

    // Add real-time email validation
    if (this.selectors.email) {
      this.selectors.email.addEventListener('blur', this.validateEmailField.bind(this));
      this.selectors.email.addEventListener('input', this.clearEmailError.bind(this));
      this.selectors.email.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        event.stopPropagation();
        this.submit(event);
      });
    }

    /* 
    // Add event listener for collection submit button if it exists
    const collectionSubmitBtn = this.querySelector('button[type="submit"]');
    if (collectionSubmitBtn) {
      collectionSubmitBtn.addEventListener('click', this.collectionOnSubmitBISForm.bind(this));
    }
    */
  }

  collectionOnSubmitBISForm(event) {
    event.preventDefault();

    let hasError = false;
    let msg = '';
    let productSKU = '';
    let email = null;

    function isVisible(el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    // Find the visible notify-me modal
    const elements = document.querySelectorAll('.notify-me-modal');
    let visibleModal = null;

    elements.forEach((el) => {
      if (isVisible(el)) {
        visibleModal = el;
        email = el.querySelector('[name="email"]');

        // Try to find the product SKU from the button that triggered this
        const triggerBtn = event.target;
        if (triggerBtn) {
          productSKU =
            triggerBtn.getAttribute('offer-var-id') || triggerBtn.getAttribute('data-variant-id');
        }

        // Fallback: try to find from parent elements
        if (!productSKU) {
          const parent = el.closest('notify-me');
          if (parent) {
            const btn = parent.querySelector('.notify-btn, [offer-var-id], [data-variant-id]');
            if (btn) {
              productSKU = btn.getAttribute('offer-var-id') || btn.getAttribute('data-variant-id');
            }
          }
        }
      }
    });

    if (!email) {
      console.error('Email input not found in visible modal');
      return;
    }

    let emailAddress = email.value;
    emailAddress = emailAddress ? emailAddress.trim() : emailAddress;

    // Get alert code from hidden input or use default
    const alertCodeInput = document.getElementById('hdnAlertCode');
    const alertCode = alertCodeInput ? alertCodeInput.value : 'BIS';

    // Validate email using standard regex
    if (emailAddress === '') {
      hasError = true;
      msg = 'Email field is required';
    } else {
      // Standard email regex validation
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
      if (!emailRegex.test(emailAddress)) {
        hasError = true;
        msg = 'Please enter a valid email address';
      }
    }

    if (!hasError && productSKU) {
      // Submit the alert
      if (window._ltk) {
        _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
        _ltk.Alerts.Submit();
      }

      if (window._theme && window._theme.track) {
        _theme.track.trackData({ event: 'notifyMeFormSubmitted' });
      }

      alert('Thank you! We will notify you when this product becomes available.');
      document.querySelector('body').style.overflow = '';

      // Hide the modal if it exists
      if (visibleModal) {
        visibleModal.style.display = 'none';
      }

      // Hide wrapper if it exists
      const wrapper = document.querySelector('.product_alert_signup_wrapper');
      if (wrapper) {
        wrapper.classList.add('hide');
      }
    } else {
      // Show error message
      const errorContainer = visibleModal ? visibleModal.querySelector('.input-error') : null;
      if (errorContainer) {
        errorContainer.innerHTML = '';
        const newSpan = document.createElement('span');
        newSpan.setAttribute('role', 'alert');
        newSpan.textContent = msg;
        errorContainer.appendChild(newSpan);
        errorContainer.style.display = 'block';
        email.focus();
      } else {
        console.error('Error container not found');
      }
    }
  }

  setAriaHiddenBackground(hide) {
    let current = this.selectors.notifyModal;
    while (current && current !== document.body) {
      const parent = current.parentElement;
      if (parent) {
        Array.from(parent.children).forEach(sibling => {
          if (sibling !== current && sibling.tagName !== 'SCRIPT') {
            if (hide) {
              const originalValue = sibling.getAttribute('aria-hidden');
              if (originalValue !== null) {
                sibling.setAttribute('data-original-aria-hidden', originalValue);
              }
              sibling.setAttribute('aria-hidden', 'true');
            } else {
              const originalValue = sibling.getAttribute('data-original-aria-hidden');
              if (originalValue !== null) {
                sibling.setAttribute('aria-hidden', originalValue);
                sibling.removeAttribute('data-original-aria-hidden');
              } else {
                sibling.removeAttribute('aria-hidden');
              }
            }
          }
        });
      }
      current = parent;
    }
  }

  trapFocus(modalElement, onClose) {
    const tabbableSelector = 'select, input, textarea, button, a';
    const getTabbableElements = () => {
      return Array.from(modalElement.querySelectorAll(tabbableSelector))
        .filter(el => el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0);
    };

    const tabbable = getTabbableElements();
    tabbable.forEach(el => {
      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
      }
    });

    if (tabbable.length > 0) {
      tabbable[0].focus();
    }

    const keydownHandler = (e) => {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        onClose();
        return;
      }

      const currentTabbable = getTabbableElements();
      if (currentTabbable.length === 0) return;

      const first = currentTabbable[0];
      const last = currentTabbable[currentTabbable.length - 1];

      if (e.key === 'Tab' || e.keyCode === 9) {
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      const isInput = e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'textarea';
      const isArrowUp = e.key === 'ArrowUp' || e.keyCode === 38;
      const isArrowDown = e.key === 'ArrowDown' || e.keyCode === 40;
      const isArrowLeft = e.key === 'ArrowLeft' || e.keyCode === 37;
      const isArrowRight = e.key === 'ArrowRight' || e.keyCode === 39;

      if (isArrowUp || isArrowDown || (isArrowLeft && !isInput) || (isArrowRight && !isInput)) {
        if (e.target.tagName.toLowerCase() === 'textarea') {
          return;
        }
        e.preventDefault();
        const activeIndex = currentTabbable.indexOf(document.activeElement);
        if (activeIndex > -1) {
          if (isArrowDown || isArrowRight) {
            const nextIndex = (activeIndex + 1) % currentTabbable.length;
            currentTabbable[nextIndex].focus();
          } else {
            const prevIndex = (activeIndex - 1 + currentTabbable.length) % currentTabbable.length;
            currentTabbable[prevIndex].focus();
          }
        } else {
          if (isArrowDown || isArrowRight) {
            first.focus();
          } else {
            last.focus();
          }
        }
      }
    };

    modalElement.addEventListener('keydown', keydownHandler);
    return () => {
      modalElement.removeEventListener('keydown', keydownHandler);
    };
  }

  show() {
    const quickviewDialog = this.closest('quickview-dialog');
    const parentDialog = this.closest('dialog');

    if (!this.selectors.notifyModal.parentElement.classList.contains('article-notify-me-global-wrapper')) {
      let wrapper = document.querySelector('.article-notify-me-global-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'article-notify-me article-notify-me-global-wrapper';
        document.body.appendChild(wrapper);
      }
      wrapper.appendChild(this.selectors.notifyModal);
    }

    if (quickviewDialog && typeof quickviewDialog.closeDialog === 'function') {
      quickviewDialog.closeDialog();
    } else if (parentDialog && typeof parentDialog.close === 'function') {
      parentDialog.close();
    }
    
    this.selectors.notifyModal.style.display = 'block';
    if (this.selectors.notifyProductGrid != null) {
      this.selectors.notifyProductGrid?.classList.remove('sold_out_item');
      // Temporarily strip parent product card accessibility info to prevent screen reader from announcing it
      const originalLabel = this.selectors.notifyProductGrid.getAttribute('aria-label');
      if (originalLabel) {
        this.selectors.notifyProductGrid.setAttribute('data-original-aria-label', originalLabel);
        this.selectors.notifyProductGrid.removeAttribute('aria-label');
      }
      const originalRole = this.selectors.notifyProductGrid.getAttribute('role');
      this.selectors.notifyProductGrid.setAttribute('data-original-role', originalRole || 'article');
      this.selectors.notifyProductGrid.setAttribute('role', 'presentation');
    }
    document.querySelector('body').style.overflow = 'hidden';
    this.setAriaHiddenBackground(true);
    if (this._focusTrapCleanup) this._focusTrapCleanup();
    this._focusTrapCleanup = this.trapFocus(this.selectors.notifyModal, () => {
      this.hide();
    });
  }

  hide() {
    if (!this.selectors.notifyModal) return;
    this.selectors.notifyModal.style.display = 'none';
    if (this.selectors.notifyProductGrid != null) {
      this.selectors.notifyProductGrid?.classList.add('sold_out_item');
      // Restore parent product card accessibility info
      const originalLabel = this.selectors.notifyProductGrid.getAttribute('data-original-aria-label');
      if (originalLabel) {
        this.selectors.notifyProductGrid.setAttribute('aria-label', originalLabel);
        this.selectors.notifyProductGrid.removeAttribute('data-original-aria-label');
      }
      const originalRole = this.selectors.notifyProductGrid.getAttribute('data-original-role');
      if (originalRole) {
        if (originalRole === 'article') {
          this.selectors.notifyProductGrid.removeAttribute('role');
        } else {
          this.selectors.notifyProductGrid.setAttribute('role', originalRole);
        }
        this.selectors.notifyProductGrid.removeAttribute('data-original-role');
      }
    }
    document.querySelector('body').style.overflow = '';
    this.setAriaHiddenBackground(false);
    if (this._focusTrapCleanup) {
      this._focusTrapCleanup();
      this._focusTrapCleanup = null;
    }
    this.reset();
    if (this.selectors.notifyOpenBtn && document.contains(this.selectors.notifyOpenBtn)) {
      this.selectors.notifyOpenBtn.focus();
    }
  }

  submit(event) {
    event.preventDefault();

    const emailVal = this.selectors.email?.value.trim() || '';
    const errorElem = this.selectors.notifyModal?.querySelector('.input-error');
    errorElem?.classList.add('hidden');
    const errorMsg = this.getEmailValidationError(emailVal);

    if (!errorMsg) {
      const alertCode = 'BIS';
      this.submitDetails(emailVal, this.productId, alertCode);
      this.showSuccessMsg();
      if (this.selectors.notifyCloseBtn) {
        this.selectors.notifyCloseBtn.focus();
      }
      return;
    }

    this.showInputError(errorMsg);
    this.selectors.email.focus();
  }

  submitDetails(emailAddress, productSKU, alertCode) {
    if (!window._ltk) return false;
    if (!emailAddress || !productSKU || !alertCode) return false;

    _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
    _ltk.Alerts.Submit();
    _theme.track.trackData({ event: 'notifyMeFormSubmitted' });
    return true;
  }

  showSuccessMsg() {
    const header = this.selectors.notifyModal?.querySelector('.notify-modal-header');
    const footer = this.selectors.notifyModal?.querySelector('.notify-modal-footer');

    header?.classList.add('hidden');
    footer?.classList.add('hidden');
    this.selectors.formContent?.classList.add('hidden');
    this.selectors.notifySuccessMsg?.setAttribute('role', 'alert');
    this.selectors.notifySuccessMsg?.classList.remove('hidden');
  }

  reset() {
    const header = this.selectors.notifyModal?.querySelector('.notify-modal-header');
    const footer = this.selectors.notifyModal?.querySelector('.notify-modal-footer');

    header?.classList.remove('hidden');
    footer?.classList.remove('hidden');
    this.selectors.formContent?.classList.remove('hidden');
    this.selectors.notifySuccessMsg?.removeAttribute('role');
    this.selectors.notifySuccessMsg?.classList.add('hidden');

    if (this.selectors.email) {
      this.selectors.email.value = '';
    }

    this.clearEmailError();
  }

  validateEmailField() {
    const emailVal = this.selectors.email?.value.trim() || '';

    if (!emailVal) {
      this.clearEmailError();
      return;
    }

    const errorMsg = this.getEmailValidationError(emailVal);
    if (errorMsg) {
      this.showInputError(errorMsg);
      return;
    }

    this.clearEmailError();
  }

  getEmailValidationError(emailVal) {
    if (!emailVal) return 'Email field is required';

    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
    if (!emailRegex.test(emailVal)) return 'Please enter a valid email address';

    return '';
  }

  showInputError(message) {
    const errorElem = this.selectors.notifyModal?.querySelector('.input-error');
    if (!errorElem) return;

    errorElem.textContent = message;
    errorElem.classList.remove('hidden');
    this.selectors.email?.setAttribute('aria-invalid', 'true');
  }

  clearEmailError() {
    const errorElem = this.selectors.notifyModal?.querySelector('.input-error');
    errorElem?.classList.add('hidden');
    this.selectors.email?.setAttribute('aria-invalid', 'false');
  }
}
customElements.define('notify-me', NotifyMe);
